/* ============
 * Mutation types for the message module
 * ============
 *
 * The mutation types that are available
 * on the auth module.
 */
import keyMirror from 'key-mirror';

export default keyMirror({
  FETCH_PATIENTS_LIST: null,
  FETCH_PATIENTS_LIST_SUCCESS: null,
  FETCH_PATIENTS_LIST_FAIL: null,
  FETCH_PATIENTS_MESSAGE_LIST: null,
  FETCH_PATIENTS_MESSAGE_LIST_SUCCESS: null,
  FETCH_PATIENTS_MESSAGE_LIST_FAIL: null,
  SEND_MESSAGE: null,
  SEND_MESSAGE_SUCCESS: null,
  SEND_MESSAGE_FAIL: null,
  START_VIDEO_CALL: null,
  START_VIDEO_CALL_SUCCESS: null,
  START_VIDEO_CALL_FAIL: null

});
